import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'

export const ChartFrame = ({
  children,
  id,
  overflowHidden=false
}: {
  children: React.ReactNode
  id: string
  overflowHidden?:boolean
}) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) return
    if (id === 'landmass') {
        console.log("set scroll pos",ref.current.clientTop)
        window.scrollytarget = ref.current
    }
  }, [ref.current])

  return (
    <Container ref={ref} id={id} overflowHidden={overflowHidden}>
      {children}
    </Container>
  )
}

const Container = styled.div<{overflowHidden:boolean}>`
  font-family: var(--font-plex);
  margin-top: 30px;
  margin-bottom: 60px;
  overflow-x: ${({overflowHidden})=>overflowHidden?"unset":"hidden"};
  .title {
    font-weight: 700;
    font-size: 22px;
    letter-spacing: 0.4px;
    margin-bottom: 30px;
    text-align: left;
  }
  img {
    max-width: 100%;
  }
`
